module.exports = __webpack_public_path__ + "assets/img/kv-122d68ab.jpg";